import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-new-invoice-success-modal',
    templateUrl: 'new-invoice-success-modal.component.html',
    styleUrls: ['./new-invoice-success-modal.component.scss'],
    standalone: false
})
export class NewInvoiceSuccessModalComponent implements OnInit {
  @Input() public caseId: string;

  constructor(public activeModal: NgbActiveModal, private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {}

  navigateToHome() {
    this.activeModal.close();
    this.router.navigate(['home']);
  }

  navigateToAllInvoices() {
    this.activeModal.close();
    this.router.navigate(['case', this.caseId, 'economy', 'invoices', 'all']);
  }
}
